// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".primary-clinic{display:flex;align-items:center}.secondaryClinic{margin-left:25px !important}\n", ""]);
// Exports
module.exports = exports;
